/*
    Override default sensors that we can access our editing buttons inside the sortable list
    */
import { PointerSensor } from '@dnd-kit/core';

export class CustomPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: ({ nativeEvent: event }: React.PointerEvent<Element>) => {
        if (isInteractiveElement(event.target as HTMLElement)) {
          return false; // non-drag event
        }

        return true; // drag event
      },
    },
  ];
}

function isInteractiveElement(element: HTMLElement | null) {
  if (element) {
    const dragAttr = 'data-dnd-drag';
    const parent = element.parentElement;

    if (element.hasAttribute(dragAttr) || parent?.hasAttribute(dragAttr)) {
      return false; // drag event
    }
  }

  return true; // Allow all other events to go through w/o triggering drag (ie button within the sortable list)
}
